import React, { useState } from 'react';
import { PageProps, Link } from 'gatsby';
import classNames from 'classnames';
import { useStyles } from '@/hooks/useStyles';
import Hamburger from '@/components/hamburger/hamburger';
import fujistuLogo from '@/images/logos/fujitsu-logo.png';

const Menu: React.FC<PageProps> = ({ location }) => {
  const { joinClasses } = useStyles();
  const [isActiveMenu, setIsActiveMenu] = useState(false);

  const pages = [
    {
      path: '/overview',
      name: 'OVERVIEW'
    },
    {
      path: '#contact-form',
      name: 'REQUEST A DEMO'
    },
    {
      path: 'https://www.fujitsugeneral.com/',
      name: 'Fujitsu General',
      image: fujistuLogo
    }
  ];

  const getRouteClasses = (index: number, path: string) =>
    classNames('py-4 justify-center content-center', {
      'lg:pl-[10.25rem]': index !== 0,
      'text-primary':
        location.pathname.replaceAll('/', '') === path?.replaceAll('/', '')
    });

  const desktopClasses = (index?: number, path?: string) => ({
    container: classNames(
      'lg:px-[2.5rem] lg:py-0 flex lg:justify-between lg:relative lg:top-[unset] lg:left-[unset] lg:flex-row lg:max-h-full lg:translate-y-[unset] lg:w-auto lg:transition-[none]'
    ),
    listItem: getRouteClasses(index, path),
    link: classNames('md:text-[1.563rem]'),
    imageContainer: classNames('lg:max-w-[122px]')
  });
  const mobileClasses = {
    container: classNames(
      {
        isActive: isActiveMenu
      },
      'absolute left-0 top-0 translate-y-[85px] bg-white w-full max-h-0 z-[11]',
      'flex-col justify-center items-center',
      'transition-all ease-in-out overflow-hidden [&.isActive]:max-h-[200px] [&.isActive]:py-[1.25rem] sm:max-lg:duration-500'
    ),
    link: classNames('block align-middle hover:text-primary text-[1.286rem]'),
    imageContainer: classNames('w-full max-w-[72px]')
  };

  return (
    <>
      <Hamburger
        data={{
          active: isActiveMenu,
          onClickButton: () => setIsActiveMenu(!isActiveMenu)
        }}
      />
      <ul
        id="menu"
        className={joinClasses([
          desktopClasses().container,
          mobileClasses.container
        ])}
      >
        {pages.map(({ path, name, image }, i) => (
          <li
            key={path}
            className={joinClasses([desktopClasses(i, path).listItem])}
          >
            <Link
              className={joinClasses([
                desktopClasses().link,
                mobileClasses.link,
                image && desktopClasses().imageContainer,
                image && mobileClasses.imageContainer
              ])}
              to={path}
            >
              {!image && name}
              {image && <img src={image} alt={name} className="w-full" />}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};

export default Menu;
